(() => {
  'use strict';
  if (window.StockZeroPermanent) return;
  const configNode = document.getElementById('stock-zero-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  if (config.version !== 1 || config.enabled !== true || window.Shopify?.shop !== config.domain) return;
  const slots = () => [...document.querySelectorAll('[data-sza-slot]')];
  const numeric = value => /^\d+$/.test(String(value || ''));
  let stopped = false, sequence = 0, active = null, timer = null, deferred = null, dirty = false, failures = 0, lastStarted = 0;
  const interval = Number.isFinite(config.pollIntervalMs) ? Math.max(0, config.pollIntervalMs) : 60000;
  const minRefresh = Number.isFinite(config.minRefreshMs) ? Math.max(0, config.minRefreshMs) : 5000;
  const timeout = Math.max(100, Math.min(Number(config.timeoutMs) || 10000, 30000));
  const storageKey = 'sza:v1:' + config.shopId + ':' + location.pathname;
  const quantities = () => [...document.querySelectorAll('form [name="quantity"],#stquantity')];
  const quantityState = () => {
    const occurrences = new Map();
    return quantities().map(input => {
      const variant = input.closest('form')?.querySelector('[name="id"]')?.value || new URL(location.href).searchParams.get('variant') || '';
      const base = variant + ':' + (input.name || input.id);
      const ordinal = occurrences.get(base) || 0; occurrences.set(base,ordinal+1);
      return {input,key:base+':'+ordinal,value:input.value};
    });
  };
  const variantFor = source => {
    const roots = [...document.querySelectorAll('[data-sza-native]')].filter(n => n.dataset.szaNative === source);
    for (const root of roots) {
      const input = root.querySelector('[name="id"]') || root.closest('form')?.querySelector('[name="id"]');
      if (numeric(input?.value)) return input.value;
    }
    for (const node of slots().filter(n => n.dataset.szaSource === source)) {
      const input = node.closest('form')?.querySelector('[name="id"]');
      if (numeric(input?.value)) return input.value;
    }
    return null;
  };
  const fingerprint = () => location.href + '|' + [...new Set(slots().map(n => n.dataset.szaSource))].sort().map(id => id + ':' + variantFor(id)).join('|');
  const restore = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (!saved) return;
      sessionStorage.removeItem(storageKey);
      if (Date.now() - saved.at > 120000 || Date.now() < saved.at || saved.variant !== new URL(location.href).searchParams.get('variant')) return;
      if (!Array.isArray(saved.quantities)) return;
      for (const {input,key} of quantityState()) {
        const savedInput = saved.quantities.find(item => item.key === key && /^\d+$/.test(item.value));
        if (!savedInput) continue;
        const lower = Number(input.min) || 1, upper = input.max ? Number(input.max) : Infinity;
        const value = Math.max(lower, Math.min(Number(savedInput.value), upper));
        if (Number.isFinite(value)) {
          input.value = String(value);
          input.dispatchEvent(new Event('input', {bubbles:true}));
          input.dispatchEvent(new Event('change', {bubbles:true}));
        }
      }
    } catch {}
  };
  restore();
  const queue = () => {
    clearTimeout(timer);
    if (!stopped && interval > 0 && !document.hidden) timer = setTimeout(() => refresh(), Math.min(interval * 2 ** failures, 480000));
  };
  const reloadNative = source => {
    const url = new URL(location.href);
    const variant = variantFor(source);
    if (variant && /\/products\//.test(url.pathname)) url.searchParams.set('variant', variant);
    const entries = quantityState().map(({key,value}) => ({key,value}));
    if (entries.some(item => !/^\d+$/.test(item.value) || Number(item.value) < 1)) return false;
    try { sessionStorage.setItem(storageKey, JSON.stringify({at:Date.now(),variant:url.searchParams.get('variant'),quantities:entries})); } catch { return false; }
    window.location.replace(url.href);
    return true;
  };
  const notice = source => {
    if (document.querySelector('[data-sza-notice]')) return;
    const box = document.createElement('p'), button = document.createElement('button');
    box.dataset.szaNotice = ''; box.setAttribute('role','status');
    button.type = 'button'; button.textContent = config.refreshLabel || 'Stocul s-a schimbat. Actualizează pagina.';
    button.addEventListener('click', () => reloadNative(source));
    box.append(button); document.body.append(box);
  };
  const safeAnchor = (node, source, placement) => {
    const anchors = [...node.querySelectorAll('a')];
    if (anchors.length > 1) throw new Error('ambiguous-target');
    if (!anchors.length) return null;
    const original = anchors[0], target = original.dataset.stockZeroTarget;
    const url = new URL(original.getAttribute('href'), location.origin);
    if (!numeric(target) || target === source || original.dataset.stockZeroSource !== source || url.origin !== location.origin ||
        !/\/products\/[^/]+/.test(url.pathname) || !numeric(url.searchParams.get('variant'))) throw new Error('invalid-target');
    const anchor = document.createElement('a');
    anchor.className = placement === 'overlay' ? 'stock-zero__overlay' : 'btn stock-zero__cta';
    anchor.href = url.pathname + url.search;
    anchor.dataset.stockZeroSource = source; anchor.dataset.stockZeroTarget = target;
    if (original.hasAttribute('aria-label')) anchor.setAttribute('aria-label',original.getAttribute('aria-label'));
    for (const child of original.childNodes) {
      if (child.nodeType === Node.TEXT_NODE) anchor.append(document.createTextNode(child.textContent));
      else if (['SPAN','SMALL'].includes(child.nodeName)) {
        const part = document.createElement(child.nodeName.toLowerCase()); part.textContent = child.textContent; anchor.append(part);
      } else throw new Error('invalid-markup');
    }
    return anchor;
  };
  const groupRequests = live => {
    const groups = new Map();
    for (const node of live) {
      if (!numeric(node.dataset.szaSource)) throw new Error('invalid-source');
      const url = new URL(node.dataset.szaContext || location.pathname,location.origin);
      if (url.origin !== location.origin) throw new Error('invalid-context');
      if (url.pathname === location.pathname) url.search = location.search;
      else {
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id',preview);
      }
      if (/\/products\//.test(url.pathname)) {
        const variant = variantFor(node.dataset.szaSource);
        if (variant) url.searchParams.set('variant',variant);
      }
      url.searchParams.delete('sections'); url.searchParams.delete('section_id');
      const key = url.href;
      if (!groups.has(key)) groups.set(key,{url,nodes:[]});
      groups.get(key).nodes.push(node);
    }
    return [...groups.values()];
  };
  const fetchGroup = async (group, signal) => {
    const ids = [...new Set(group.nodes.map(n => n.closest('[id^="shopify-section-"]')?.id.slice(16)))];
    const sectionMode = ids.length > 0 && ids.length <= 5 && ids.every(Boolean);
    const url = new URL(group.url);
    if (sectionMode) url.searchParams.set('sections',ids.join(','));
    const response = await fetch(url.href,{method:'GET',credentials:'same-origin',cache:'no-store',redirect:'error',signal});
    if (!response.ok) throw new Error('http-error');
    if (response.url && new URL(response.url).origin !== location.origin) throw new Error('redirect-origin');
    let text;
    if (sectionMode) {
      const parts = await response.json();
      if (!parts || ids.some(id => typeof parts[id] !== 'string' || !parts[id])) throw new Error('null-section');
      text = ids.map(id => parts[id]).join('');
    } else text = await response.text();
    const doc = new DOMParser().parseFromString(text,'text/html');
    return {group,doc};
  };
  const missingSnapshots = async (results, signal) => {
    const pending = new Map();
    for (const {group,doc} of results) {
      const available = [...doc.querySelectorAll('[data-sza-slot]')];
      for (const original of group.nodes) {
        const source = original.dataset.szaSource;
        if (available.some(n => n.dataset.szaSource === source && n.dataset.szaKey === original.dataset.szaKey)) continue;
        const url = new URL(original.dataset.szaProductUrl || '', location.origin);
        if (url.origin !== location.origin || !/\/products\/[^/]+/.test(url.pathname)) throw new Error('invalid-product-context');
        for (const key of ['preview_theme_id','pb']) {
          const value = new URL(location.href).searchParams.get(key);
          if (value) url.searchParams.set(key,value);
        }
        const variant = variantFor(source);
        if (variant) url.searchParams.set('variant',variant);
        const previous = pending.get(source);
        if (previous && previous.url.href !== url.href) throw new Error('ambiguous-product-context');
        if (!previous) pending.set(source,{url,nodes:[]});
      }
    }
    const snapshots = new Map();
    await Promise.all([...pending].map(async ([source,group]) => {
      const {doc} = await fetchGroup(group,signal);
      snapshots.set(source,{doc,path:group.url.pathname});
    }));
    return snapshots;
  };
  async function refresh() {
    if (stopped || document.hidden) return false;
    const live = slots();
    if (!live.length) { queue(); return false; }
    active?.abort();
    const controller = new AbortController(), id = ++sequence, before = fingerprint();
    active = controller; lastStarted = Date.now();
    const deadline = setTimeout(() => controller.abort(),timeout);
    try {
      const results = [];
      for (const group of groupRequests(live)) results.push(await fetchGroup(group,controller.signal));
      if (stopped || controller.signal.aborted || id !== sequence || fingerprint() !== before) return false;
      const fallbacks = await missingSnapshots(results,controller.signal);
      if (stopped || controller.signal.aborted || id !== sequence || fingerprint() !== before) return false;
      const plans = [], sourceStates = new Map();
      for (const {group,doc} of results) {
        const available = [...doc.querySelectorAll('[data-sza-slot]')];
        for (const original of group.nodes) {
          if (!original.isConnected) throw new Error('detached-slot');
          const source = original.dataset.szaSource;
          const fallback = fallbacks.get(source);
          const fresh = available.find(n => n.dataset.szaSource === source && n.dataset.szaKey === original.dataset.szaKey) ||
            [...(fallback?.doc.querySelectorAll('[data-sza-slot]') || [])].find(n => n.dataset.szaSource === source &&
              n.dataset.szaPlacement === original.dataset.szaPlacement && n.dataset.szaProductUrl === fallback.path);
          if (!fresh || !['true','false'].includes(fresh.dataset.szaBuyable)) throw new Error('incomplete-snapshot');
          const anchor = safeAnchor(fresh,source,original.dataset.szaPlacement);
          const buyable = fresh.dataset.szaBuyable === 'true';
          if (buyable && anchor) throw new Error('inconsistent-source');
          const value = JSON.stringify([buyable,anchor?.dataset.stockZeroTarget || '',anchor?.getAttribute('href') || '']);
          if (sourceStates.has(source) && sourceStates.get(source).value !== value) throw new Error('inconsistent-placements');
          sourceStates.set(source,{value,buyable,alternative:!!anchor});
          plans.push({original,fresh,anchor});
        }
      }
      const transition = plans.find(p => p.original.dataset.szaBuyable !== p.fresh.dataset.szaBuyable);
      if (transition) {
        const source = transition.original.dataset.szaSource;
        if (dirty || document.activeElement?.matches('input,textarea,select') || !reloadNative(source)) {
          if (transition.fresh.dataset.szaBuyable === 'false') {
            for (const form of document.querySelectorAll('form')) {
              if (form.querySelector('[data-sza-source="'+source+'"]')) for (const b of form.querySelectorAll('button[name="add"]')) b.disabled = true;
            }
          }
          notice(source);
        }
        return true;
      }
      for (const {original,anchor} of plans) {
        original.replaceChildren(...(anchor?[anchor]:[]));
      }
      for (const native of document.querySelectorAll('[data-sza-native]')) {
        const state = sourceStates.get(native.dataset.szaNative);
        if (state) native.classList.toggle('stock-zero-native-buy',state.alternative);
      }
      failures = 0;
      document.dispatchEvent(new CustomEvent('sza:updated',{detail:{sources:[...sourceStates.keys()]}}));
      return true;
    } catch (error) {
      if (error.name !== 'AbortError') {
        failures = Math.min(failures+1,3);
        document.dispatchEvent(new CustomEvent('sza:error',{detail:{reason:error.message}}));
      }
      return false;
    } finally {
      clearTimeout(deadline);
      if (id === sequence) { active = null; queue(); }
    }
  }
  const requestSoon = () => {
    clearTimeout(deferred);
    deferred = setTimeout(() => refresh(),Math.max(0,minRefresh-(Date.now()-lastStarted)));
  };
  const edit = event => {
    const input = event.target;
    if (!input.matches?.('input,textarea,select')) return;
    if (input.name === 'id' || input.name?.startsWith('options') || input.id === 'sticky-variants') {
      sequence++; active?.abort(); requestSoon();
    } else if (!['quantity','stquantity'].includes(input.name) && input.type !== 'hidden') dirty = true;
  };
  document.addEventListener('input',edit); document.addEventListener('change',edit);
  document.addEventListener('visibilitychange',() => { if (document.hidden) { active?.abort(); clearTimeout(timer); } else requestSoon(); });
  window.addEventListener('focus',requestSoon);
  const observer = new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches('[data-sza-slot]') || n.querySelector('[data-sza-slot]'))))) requestSoon();
  });
  observer.observe(document.body,{childList:true,subtree:true});
  window.StockZeroPermanent = Object.freeze({
    version:'1.0.0',
    refresh,
    stop() {
      stopped = true; sequence++; active?.abort(); clearTimeout(timer); clearTimeout(deferred); observer.disconnect();
      document.removeEventListener('input',edit); document.removeEventListener('change',edit);
      for (const node of slots()) node.replaceChildren();
      for (const node of document.querySelectorAll('[data-sza-native]')) node.classList.remove('stock-zero-native-buy');
      document.querySelector('[data-sza-notice]')?.remove();
    }
  });
  queue();
})();


;(() => {
  'use strict';
  if (window.SzaTitleNoteSpacing) return;
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) return;
  const metrics = new Map();
  const watched = new WeakSet();
  let pending = false;
  function ink(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const range = document.createRange();
    let top = Infinity, bottom = -Infinity, node;
    while ((node = walker.nextNode())) {
      const parent = node.parentElement;
      const style = getComputedStyle(parent);
      if (style.visibility === 'hidden' || style.display === 'none') continue;
      const font = style.fontStyle + ' ' + style.fontWeight + ' ' + style.fontSize + ' ' + style.fontFamily;
      context.font = font;
      for (let i = 0; i < node.length; i++) {
        let character = node.data[i];
        if (/\s/.test(character)) continue;
        if (style.textTransform === 'uppercase') character = character.toLocaleUpperCase();
        else if (style.textTransform === 'lowercase') character = character.toLocaleLowerCase();
        const key = context.font + '|' + character;
        let metric = metrics.get(key);
        if (!metric) {
          const measured = context.measureText(character);
          metric = {ascent: measured.actualBoundingBoxAscent, descent: measured.actualBoundingBoxDescent, fontAscent: measured.fontBoundingBoxAscent};
          if (!Number.isFinite(metric.fontAscent)) return null;
          metrics.set(key, metric);
        }
        range.setStart(node, i);
        range.setEnd(node, i + 1);
        const box = range.getBoundingClientRect();
        if (!box.height || !box.width) continue;
        const baseline = box.top + metric.fontAscent;
        top = Math.min(top, baseline - metric.ascent);
        bottom = Math.max(bottom, baseline + metric.descent);
      }
    }
    return Number.isFinite(top) && Number.isFinite(bottom) ? {top, bottom} : null;
  }
  function update() {
    pending = false;
    for (const note of document.querySelectorAll('.sza-product-summary')) {
      const title = note.previousElementSibling;
      if (!title || !title.textContent.trim() || !note.getClientRects().length || !note.getBoundingClientRect().height) continue;
      if (!watched.has(note)) { resize.observe(note); watched.add(note); }
      if (!watched.has(title)) { resize.observe(title); watched.add(title); }
      const titleInk = ink(title), noteInk = ink(note);
      if (!titleInk || !noteInk) continue;
      const currentMargin = parseFloat(getComputedStyle(note).marginTop) || 0;
      const correctedMargin = currentMargin + 10 - (noteInk.top - titleInk.bottom);
      if (Number.isFinite(correctedMargin) && Math.abs(correctedMargin - currentMargin) > 0.03) {
        note.style.setProperty('--sza-title-note-space', correctedMargin.toFixed(4) + 'px');
      }
    }
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  }
  const resize = new ResizeObserver(schedule);
  const mutation = new MutationObserver(schedule);
  function start() {
    mutation.observe(document.documentElement, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden']});
    schedule();
    document.fonts?.ready.then(() => { metrics.clear(); schedule(); });
    document.fonts?.addEventListener('loadingdone', () => { metrics.clear(); schedule(); });
  }
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('sza:updated', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  window.SzaTitleNoteSpacing = Object.freeze({version: '1.0.1'});
})();

;(() => {
  'use strict';
  if (window.SzaImageCenter) return;
  const watched = new WeakSet();
  let pending = false;
  const visible = image => image.getBoundingClientRect().width > 0 && image.getBoundingClientRect().height > 0;
  function update() {
    pending = false;
    for (const gallery of document.querySelectorAll('.product-gallery')) {
      if (!gallery.querySelector(':scope > .sza-slot > .stock-zero__overlay')) continue;
      if (!watched.has(gallery)) {
        watched.add(gallery);
        resize.observe(gallery);
        new MutationObserver(records => {
          if (records.some(record => record.target !== gallery)) schedule();
        }).observe(gallery, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'src', 'srcset']});
        gallery.addEventListener('load', schedule, true);
        gallery.addEventListener('transitionend', schedule);
      }
      const active = gallery.querySelector('.product-gallery__main_item.slick-current img, .product-image-lg.swiper-slide-active img');
      const image = active && visible(active) ? active : [...gallery.querySelectorAll('.product-gallery__main_item img, .product-image-lg img')].find(visible);
      if (!image) continue;
      if (!watched.has(image)) { watched.add(image); resize.observe(image); }
      const box = image.getBoundingClientRect(), origin = gallery.getBoundingClientRect();
      const x = box.left - origin.left - gallery.clientLeft + box.width / 2;
      const y = box.top - origin.top - gallery.clientTop + box.height / 2;
      for (const [name, value] of [['--sza-image-center-x', x], ['--sza-image-center-y', y]]) {
        const next = value.toFixed(4) + 'px';
        if (gallery.style.getPropertyValue(name) !== next) gallery.style.setProperty(name, next);
      }
    }
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
  const resize = new ResizeObserver(schedule);
  function start() {
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.product-gallery') || node.querySelector('.product-gallery'))))) schedule();
    }).observe(document.body, {subtree: true, childList: true});
    schedule();
    document.fonts?.ready.then(schedule);
  }
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('sza:updated', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  window.SzaImageCenter = Object.freeze({version: '1.0.0'});
})();
